import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { acceptPublicOffer } from '../../../thunks/joinOtaLegalShort/acceptPublicOffer';

const initialState = false;

const isLoadingSlice = createSlice({
  name: 'isLoading',
  initialState,
  reducers: {
    setIsLoading(_, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(acceptPublicOffer.pending, () => true);

    builder.addCase(acceptPublicOffer.fulfilled, () => false);

    builder.addCase(acceptPublicOffer.rejected, () => false);
  },
});

export const { reducer: isLoadingReducer } = isLoadingSlice;
